import useObservableElement from 'hooks/useObservableElement';
import { WithObservabilityType } from './types';

function withObservability<ComponentProps>(Component) {
  return function HOC(props: ComponentProps & WithObservabilityType) {
    const { index } = props;
    const componentRef = useObservableElement(index);

    return (
      <div ref={componentRef}>
        <Component {...props} />
      </div>
    );
  };
}

export default withObservability;
